import React from "react";
import { container_classname } from "./constants";
import Image from "next/image";
import { IoArrowForward } from "react-icons/io5";

interface SpotlightCard {
    icon: string;
    title: string;
    description: string;
}
interface Spotlight {
    title: string;
    description: string;
    cards: SpotlightCard[];
    ctaLink: string;
    ctaText: string;
    footnote: string;
}

const defaultSpotlightData: Spotlight = {
    title: "Drive two-way conversations. Achieve multi-fold business growth.",
    description:
        "Effective July 1, 2025, businesses will be charged per template and not per conversation (as done currently) by Meta. All incoming/user-initiated messages will continue to remain free. The four categories of conversations, as defined by Meta, bear different charges.",
    ctaText: "View category-wise conversation costs",
    ctaLink: "https://docs.gallabox.com/pricing-and-billing-modules/conversation-pricing",
    footnote: "Note: All incoming messages are free, effective November 1, 2024.",
    cards: [
        {
            icon: "/pricing-page/marketing-conversation.svg",
            title: "Marketing conversations",
            description: "Product/service updates, promotions, and offers.",
        },
        {
            icon: "/pricing-page/utility-conversation.svg",
            title: "Utility conversations",
            description: "Post-purchase alerts such as transaction confirmations and payment updates.",
        },
        {
            icon: "/pricing-page/authentication-conversation.svg",
            title: "Authentication conversations",
            description: "Sending one-time passwords (OTPs) for account recovery and verification.",
        },
        {
            icon: "/pricing-page/service-conversation.svg",
            title: "Service conversations",
            description: "User-initiated conversations, which enable businesses to send free-form texts.",
        },
    ],
};

const SpotlightSection2: React.FC<{ spotlight?: Spotlight }> = ({ spotlight = defaultSpotlightData }) => {
    const { title, description, cards, ctaLink, ctaText, footnote } = spotlight;
    return (
        <section className="bg-white py-20">
            <div className={`${container_classname}`}>
                <h2 className="md:text-5xl text-4xl mb-6" style={{ fontFamily: "Degular Display" }}>
                    {title}
                </h2>
                <p className="mb-9">{description}</p>
                <div className="grid grid-cols-1 lg:grid-cols-4 gap-7">
                    {cards.map((card, index) => (
                        <div key={index} className="p-7 bg-gray-50 border border-gray-300 border-solid rounded">
                            <Image src={card.icon} width={35} height={35} alt={card.title} className="w-9 h-9" />
                            <h3 className="text-2xl font-semibold mt-6">{card.title}</h3>
                            <p className="mt-4">{card.description}</p>
                        </div>
                    ))}
                </div>
                <p className="mt-8 mb-4">{footnote}</p>
                <a href={ctaLink} className="text-blue-600 text-lg no-underline hover:no-underline flex items-center gap-x-2">
                    {ctaText} <IoArrowForward />
                </a>
            </div>
        </section>
    );
};

export default SpotlightSection2;
